import { hasPermission } from "../config/navigation";
import adminStore from "../store/admin";

function update(el, binding) {
  const [moduleName, action = "read"] = String(binding.value || "").split(":");
  const allowed = !moduleName || hasPermission(adminStore.admin, moduleName, action);
  if (el.__permissionDisplay === undefined) el.__permissionDisplay = el.style.display;
  el.style.display = allowed ? el.__permissionDisplay : "none";
}

export default { bind: update, update, componentUpdated: update };
